import { render, staticRenderFns } from "./vFrontOfPackageConfig.vue?vue&type=template&id=58fcfbea"
import script from "./vFrontOfPackageConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./vFrontOfPackageConfig.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports